import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CitySearchResponse, OCC_ENDPOINTS } from '@city/const';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OccCitySearchService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
  ) {}

  loadSuggestions(query: string): Observable<CitySearchResponse> {
    const params = new HttpParams().set('query', query);

    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.search);

    return this.http.get<CitySearchResponse>(url, {
      params,
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.search),
    });
  }
}
